import { Typography } from '@mui/material';
import React from 'react';
import SectionHeader from './SectionHeader';

function RegistrationAndAttendance() {
  return (
    <>
      <SectionHeader>Registration</SectionHeader>
      <Typography variant="body2">
        <ul>
          <li>
            Every individual staying on the grounds is required to register.
          </li>
          <li>
            Any individual 17 years of age or younger must be accompanied during
            the week of Harmony Hill Singing School by a parent or guardian, or
            the pastor of the Primitive Baptist church the individual attends.
          </li>
          <li>
            No student may arrive at or leave Harmony Hill at any time, between
            registrations on Sunday and check-out on either Friday or Saturday,
            unless accompanied by parent, guardian or pastor.
          </li>
          <li>
            Parents, especially, please understand that older siblings under the
            age of 21 years in your family may not take younger siblings from
            the Hill nor return them to the Hill. That will be your/ the
            guardian’s responsibility, or your pastor’s. Remember, you must be
            here with them anyway.
          </li>
          <li>
            It may be necessary to make exceptions among Primitive Baptist
            families on a case-by-case basis. As Primitive Baptists we have a
            source of accountability with the Primitive Baptist churches we seek
            to serve.
          </li>
          <li>
            There will be no exceptions made for anyone who is not Primitive
            Baptist, as we have no accountability resource for those persons.
          </li>
        </ul>
      </Typography>
      <SectionHeader>Attendance</SectionHeader>
      <Typography variant="body2">
        <ul>
          <li>
            All students enrolled in Harmony Hill Singing School are required to
            <b> attend classes, assemblies, and vesper services as scheduled.</b>
          </li>
          <li>
            All students and adults enrolled in Harmony Hill Singing School are
            required to <b>abide by the regulations of the school</b>
          </li>
          <li>
            Students may obtain permission for missing class ONLY from their
            individual instructor.
          </li>
          <li>
            All adults registered at Harmony Hill Singing School are encouraged
            to attend classes, assemblies, and vespers services.
          </li>
          <li>
            We expect any students to be closely supervised by the adult(s)
            responsible for them during singing school.
          </li>
          <li>
            The administrative staff must approve any exceptions to attendance
            requirements.
          </li>
        </ul>
      </Typography>
      <SectionHeader>Leaving the Hill during Singing School</SectionHeader>
      <Typography variant="body2">
        <ul>
          <li>
            No student is to leave the Singing School grounds for any reason
            EXCEPT after obtaining permission from the ADULT COUNSELORS, to be
            specified.
          </li>
          <li>
            ANYONE (INCLUDING ADULTS) leaving the hill for any reason MUST:
          </li>
          <ul>
            <li>properly SIGN OUT at the office upon leaving, and</li>
            <li>properly SIGN IN at the office upon returning</li>
          </ul>
        </ul>
      </Typography>
    </>
  );
}

export default RegistrationAndAttendance;
